import { NgModule } from "@angular/core";
import { TriggerScheduleEditorComponent } from "@app2/trigger-schedules/trigger-schedule-editor.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app2/shared/shared.module";
import { TriggerScheduleIntervalDisplayComponent } from "@app2/triggers/trigger-schedule-interval-display.component";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
    ],
    declarations: [
        TriggerScheduleEditorComponent,
        TriggerScheduleIntervalDisplayComponent,
    ],
    exports: [
        TriggerScheduleEditorComponent,
        TriggerScheduleIntervalDisplayComponent,
    ],
})
export class TriggerScheduleSharedModule {
}
